import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Modal, Card, CardBody, Collapse, ModalHeader } from 'reactstrap';
import SurveyAnswerComments from '../comment/surveyComments';

const AnswerModal = ({
  isOpen,
  toggle,
  question,
  participants_count,
  answer,
  ratio,
  comments,
}) => (
  <div>
    <Modal isOpen={isOpen} toggle={toggle} className="modal-lg comment-modal">
      <Card className="bg-white styled-box-shadow">
        <ModalHeader
          toggle={toggle}
          className="bg-white cursor-pointer d-flex modal-header"
        >
          {question}
          <div className="float-right mr-4">
            <span className="question-count text-muted ml-4">
              <FontAwesomeIcon className="mr-0" icon="users" />{' '}
              {participants_count}
            </span>
          </div>
        </ModalHeader>
        <CardBody>
          <div className="row">
            <div className="col-md-4">{answer.title}</div>
            <div className="col-md-3">
              <div className="report-status-bar ">
                <div
                  className="report-status-fill"
                  style={{
                    width: `${ratio * 100}%`,
                    borderBottomRightRadius: `${ratio === 1 ? '25px' : ''}`,
                    borderTopRightRadius: `${ratio === 1 ? '25px' : ''}`,
                  }}
                />
              </div>
            </div>
            <div className="col-md-3">{(ratio * 100).toFixed(2)}%</div>
            <div className="col-md-1">{answer.answer_count}</div>
            {answer.comments_count > 0 ? (
              <div className="col-md-1">
                <FontAwesomeIcon className="fa-2x comment-box" icon="comment" />
                <span className="comments-count">{answer.comments_count}</span>
              </div>
            ) : null}
          </div>
          <SurveyAnswerComments comments={comments} />
        </CardBody>
      </Card>
    </Modal>
  </div>
);

export default AnswerModal;

AnswerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  question: PropTypes.string.isRequired,
  participants_count: PropTypes.number.isRequired,
  answer: PropTypes.object.isRequired,
  ratio: PropTypes.number.isRequired,
  comments: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/reports/AnswerModal.js